import { render, staticRenderFns } from "./ValidacaoDetalhes.vue?vue&type=template&id=5e20a12a"
import script from "./ValidacaoDetalhes.vue?vue&type=script&lang=js"
export * from "./ValidacaoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports